import { AttributeCode } from 'services/model/model.service';

export const createArticleNameFromAttributes = (attributes: Record<AttributeCode, string>) => {
  return attributes
    ? `${attributes?.prdName ?? ''}, ${attributes?.styBrandColor ?? ''}, ${attributes?.artSize ?? ''}`
    : '';
};

export const createStyleNameFromAttributes = (attributes: Record<AttributeCode, string>) => {
  return attributes ? `${attributes?.prdName ?? ''}, ${attributes?.styBrandColor ?? ''}` : '';
};

export const articleLink = (articleEAN: string, tab = 'performance') =>
  `/article/${articleEAN}/${tab}${location.search}`;

export const productLink = (productNumber: string, tab = 'performance') =>
  `/product/${encodeURIComponent(productNumber)}/${tab}${location.search}`;

export const categoryLink = (category: string, tab = 'performance') =>
  `/category/${encodeURIComponent(category)}/${tab}${location.search}`;

export const encodeStyle = (productNumber: string, style: string) => encodeURIComponent(`${productNumber}||${style}`);

export const decodeStyle = (encodedStyle: string) => {
  const decodedParts = decodeURIComponent(encodedStyle).split('||');
  return {
    productNumber: decodedParts[0],
    style: decodedParts[1],
  };
};

export const styleLink = (productNumber: string, style: string, tab = 'performance') =>
  `/style/${encodeStyle(productNumber, style)}/${tab}${location.search}`;
